<div class="workout-log-table mt-4">
  <h4>Recent Workouts</h4>
  <table class="table table-striped">
    <thead>
      <tr>
        <th>Date</th>
        <th>Name</th>
        <th>Exercises</th>
        <th>Notes</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let w of workoutLog" (click)="onWorkoutClick(w)" style="cursor:pointer;">
        <td>{{ w.date | date:'shortDate' }}</td>
        <td>{{ w.name }}</td>
        <td>{{ w.exercises.length }}</td>
        <td>{{ w.notes }}</td>
      </tr>
    </tbody>
  </table>
</div>

